import * as React from "react";

import type {GAEModule} from "@khan/data-gql-core";

import type {ApolloGqlClient} from "./types.ts";

interface ApolloRouterContextData {
    /**
     * The GAEModule to use by default.
     */
    module: GAEModule;
    /**
     * The ApolloGqlClient to use for Apollo-based GQL operations.
     */
    client: ApolloGqlClient | null | undefined;
}

export const ApolloRouterContext: React.Context<ApolloRouterContextData> =
    React.createContext<ApolloRouterContextData>({
        module: "default",
        client: null,
    });
ApolloRouterContext.displayName = "ApolloRouterContext";
